import React from 'react'
import cookie from 'isomorphic-cookie'
import { useRouter } from 'next/router'

import { useModalManager } from '~/hooks'
import Icon from '~/truck/icon'
import Image from '~/truck/image'
import NewButton from '~/truck/new-button/NewButton'
import { isProduction } from '~/utils'
import { baseUrls, cookieNames } from '~/utils/constants'

import Modal from '../modal'

interface WeakPasswordModalProps {
  modalId: number
  onAfterClose?: () => void
}

// TODO: (TEC-3081) Remove WeakPasswordModal after date
function WeakPasswordModal(props: WeakPasswordModalProps) {
  const { modalId, onAfterClose } = props

  const router = useRouter()

  const modalManager = useModalManager()

  const handleClose = () => {
    cookie.save(cookieNames.WEAK_PASSWORD_MODAL_CLOSED, 1, {
      secure: isProduction,
    })

    modalManager.closeModal(modalId)

    onAfterClose?.()
  }

  const handleChangePassword = () => {
    handleClose()

    router.push('/change-password')
  }

  return (
    <Modal
      onClose={handleClose}
      className="absolute left-1/2 top-1/2 !h-auto w-[85%] max-w-[480px] -translate-x-1/2 -translate-y-1/2 !overflow-y-hidden rounded p-6 shadow-md md:w-auto md:max-w-[520px]"
    >
      <div className="flex items-center justify-end">
        <Icon color="black30" onClick={handleClose} type="close" size="md" />
      </div>
      <div className="flex flex-col items-center gap-4 text-center">
        <Image
          alt="paper problem"
          src={`${baseUrls.CLOUDINARY}/v1600269083/sellers/resources/paper-problem.svg`}
          height={72}
        />
        <h4 className="font-semibold">Tu contraseña es muy débil</h4>
        <p className="text-slate-500">
          Hola, hemos detectado que tu contraseña es muy débil. Por tu seguridad, te recomendamos cambiarla hasta antes
          del <strong>31 de agosto</strong>.
        </p>
        <NewButton className="w-auto" onClick={handleChangePassword}>
          Cambiar Contraseña
        </NewButton>
      </div>
    </Modal>
  )
}

export default WeakPasswordModal
